import * as zod from 'zod';

export const validationUsuarioNovo = zod.object({
  nome: zod
    .string({ required_error: 'O campo nome não pode ser vazio.' })
    .max(191, { message: 'O campo pode conter no máxiom 191 caracteres' })
    .min(1, { message: 'O campo pode conter no mínimo 1 caracteres' }),
  email: zod
    .string({ required_error: 'O campo documento não pode ser vazio.' })
    .max(191, { message: 'O campo pode conter no máxiom 191 caracteres' })
    .min(1, { message: 'O campo pode conter no mínimo 1 caracteres' }),
  password: zod
  .string({ required_error: 'O campo telefone não pode ser vazio.' })
  .max(191, { message: 'O campo pode conter no máxiom 191 caracteres' })
  .min(1, { message: 'O campo pode conter no mínimo 1 caracteres' }),
  status: zod
  .string({ required_error: 'O campo telefone não pode ser vazio.' })
  .max(191, { message: 'O campo pode conter no máxiom 191 caracteres' })
  .min(1, { message: 'O campo pode conter no mínimo 1 caracteres' }),
  tipo: zod
  .string({ required_error: 'O campo telefone não pode ser vazio.' })
  .max(191, { message: 'O campo pode conter no máxiom 191 caracteres' })
  .min(1, { message: 'O campo pode conter no mínimo 1 caracteres' }),

});

export const validationUsuarioEditar = validationUsuarioNovo.extend({
  password: zod
    .string()
    .max(191, { message: 'O campo pode conter no máxiom 191 caracteres' })
    .optional()
    .or(zod.literal('')),
});

export type formUsuarioNovo = zod.infer<typeof validationUsuarioNovo>;
export type formUsuarioEditar = zod.infer<typeof validationUsuarioEditar>;
